/**
 * Get element child node at the given coordinates
 * @param {Element} HTML element
 * @param {Float|Integer} x
 * @param {Float|Integer} y
 * @returns {Node|Boolean}}
 */
export var getTextNodeFromPoint = function getTextNodeFromPoint(element, x, y) {
  var nodes = element.childNodes;
  var range = document.createRange();

  for (var i = 0; i < nodes.length; i++) {
    var node = nodes[i];

    if (node.nodeType !== Node.TEXT_NODE) {
      continue;
    }

    range.selectNodeContents(node);
    var rect = range.getBoundingClientRect();

    if (x >= rect.left && y >= rect.top && x <= rect.right && y <= rect.bottom) {
      return node;
    }
  }

  return false;
};